var isPlainObject = require("./isPlainObject");
function customOmitClone(value) {
  return isPlainObject(value) ? void 0 : value;
}
module.exports = customOmitClone;
